import axios from 'axios';

class ProjectService {
    constructor() {
        this.baseURL = process.env.VUE_APP_BACKEND_URL;
    }

    async getProjects() {
        try {
            const response = await axios.get(`${this.baseURL}/project`);
            return response.data.data;
        } catch (error) {
            console.error('Error fetching projects:', error);
            throw error;
        }
    }

    async getProjectDetails(projectId) {
        try {
            const response = await axios.get(`${this.baseURL}/project/${projectId}`);
            return response.data.data;
        } catch (error) {
            console.error('Error fetching project details:', error);
            throw error;
        }
    }

    async getProjectCharts(projectId) {
        try {
            const response = await axios.get(`${this.baseURL}/chart?projectId=${projectId}`);
            return response.data.data;
        } catch (error) {
            console.error('Error fetching project charts:', error);
            throw error;
        }
    }

    async fetchAllPartitions(projectId) {
        try {
            const response = await axios.get(`${this.baseURL}/partition?projectId=${projectId}`);
            return response.data.data;
        } catch (error) {
            console.error('Error fetching partitions:', error);
            throw error;
        }
    }

    async getChartById(chartId, projectId) {
        try {
            const response = await axios.get(`${this.baseURL}/chart?projectId=${projectId}/${chartId}`);
            return response.data.data;
        } catch (error) {
            console.error('Error fetching chart:', error);
            throw error;
        }
    }
}

export const projectService = new ProjectService(); 